export default __webpack_public_path__ + "static/media/RemoveIcon.f68b4fc0.svg";